<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/flat-design-dark">扁平化设计 黑色</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="http://zhuti.xiaomi.com/detail/f0ca4960-5906-4594-8067-9ee0996d7c32" >前往下载</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
		<div class="card-content" >
			<div class="description-container" style="text-align: center;" >
				<div>
					<h1>扁平化设计 黑色</h1>
					<h3>与众不同的新鲜的感受</h3>
					<p>各种精致的设计要素，造就了舒适的视觉效果，让这一切结合得恰到好处。
					</p>
				</div>
			</div>
			<div class="img-container" >
				<img src="@/assets/Mi_Theme/Flat_Design_Dark/tile.png" >
			</div>
		</div>
	</div>

	<div class="card-container" >
		<div class="card-content" >
		<b-row no-gutters>
			<b-col sm="6">
			
			<div class="img-container" >
				<img src="@/assets/Mi_Theme/Flat_Design_Dark/appose.png" >
			</div>
				
			</b-col>
			<b-col sm="6">
			
			<div class="description-container">
				<div>
				<h2>简洁，但却不简单</h2>
				<h3>自然而然又赏心悦目</h3>
				<p>纯净黑暗的界面，搭配简约明晰的图标设计，带着这份深邃与舒适融入你的夜生活。
				</p>
				</div>
			</div>
			
			</b-col>
		</b-row>
		</div>
	</div>    

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
export default {
    methods: {
        leaveFor() {
            this.$ga.event('mi-theme', 'miStore', 'flat-design-dark', 1)
            },
	},
}
</script>